module.exports = __webpack_public_path__ + "img/down_caret_pink.638d2994.svg";